import React, { useState, useEffect } from "react";
import "../../components/AddStages/AddStages.css";
import axios from "axios";

const AddStages = ({tokenStorage,openAddProfile,setOpenAddProfile}) => {
  const [statusDetailResponse, setStatusResponse] = useState([]);
  const [selectedValue, setSelectedValue] = useState(null);
  const baseAPI = process.env.REACT_APP_API_URL;
  const [formData, setFormData] = useState({
    StageID: "",
    StatusID: "",
    StageName: "",

    createdBy: "Vishal",
    is_active: "true",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      // Include selected department in the formData
      const postData = {
        ...formData,       
      };

      // Make a POST request to your API endpoint with updated postData
      const response = await axios.post(
        `${baseAPI}adminpost/AddStage`,
        postData, // Send updated postData as the request body
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );

      // Optionally, reset the form
      setFormData({
        StageID: "",
        StatusID: "",
        StageName: "",

        createdBy: "",
        is_active: "",
      });

      // Clear the selected department value
      setSelectedValue("");
      tokenStorage();
      setOpenAddProfile (!openAddProfile); 
    } catch (error) {
      // Handle errors (e.g., show an error message)
      console.error("Error posting data:", error);
    }
  };

  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    //console.log(storedToken);

    if (storedToken) {
      axios
        .get(
          `${baseAPI}adminget/GETStatus?ID=0`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          //console.log(response.data.data);
          setStatusResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }, []);

  const handleSelectChange = (event) => {
    // Handle the select input change and update the selected value
    formData.StatusID = event.target.value;
    //setSelectedValue(event.target.value);
    
  };

  return (
    <div className="container-fluid">
      <br />

      <div className="stagesDetail">
        <div className="stages-form" >
          <table style={{ width: "100%" }}>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
            <tr className="tableHeading">
              <td>Status Name*</td>
              <td>Stages Name*</td>
            </tr>

            <tr>
              <td>
              <select
                  name="StatusID" 
                  onChange={handleSelectChange}
                  style={{ height: "29px" }}
                >
                  <option value="">Select an option</option>
                  {statusDetailResponse.map((item) => (
                    <option value={item.statusid}>
                      {item.statusname}
                    </option>
                  ))}
                </select>
              </td>
              <td>
              <input
                  type="text"
                  name="StageName"
                  value={formData.StageName}
                  placeholder="Please Enter*"
                  onChange={handleChange}
                />
              </td>
            
            </tr>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
          </table>
          <br />
          <hr />
          <div className="reset-addStages-button">
          <button  type="submit" onClick={handleSubmit}  style={{marginRight: "10px", backgroundColor: "#5B489D", color: "white"}}>
              Add Stages
            </button>
            <button style={{ backgroundColor: "#F15843", color: "white" }}>
              Reset
            </button>
            
          </div>
        </div>
      </div>
      <br />
    </div>
  );
};

export default AddStages;
